import React from "react";
import Layout from "./layout/Layout";
import { useTranslation } from "react-i18next";
import Logo from "../assets/dmn_logo.png";
import { assetUrl } from "../utils/assetUrl";
const NotFoundPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Layout
      main={
        <div className="info-page-container">
          <img src={assetUrl(Logo)} alt="DesignMyNight Logo" className="logo" />
          <h1 className="gc-heading">404</h1>
          <p className="description">{t("page_not_found") || "Page not found."}</p>
        </div>
      }
      aside={undefined}
    />
  );
};

export default NotFoundPage;
